import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import banner from '../../assets/images/aboutus.jpg';
import { FaShield, FaHouse, FaMobileButton, FaHandHoldingDollar, FaTags, FaUserGroup } from "react-icons/fa6";
import OurMission from '../../assets/images/OurMission.jpg';
import OurVision from '../../assets/images/OurVision.jpg';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';

const Aboutus = () => {
    return (
        <>
            <Header />

            <section id='pagebanner'>
                <div className='banner-block'>
                    <img src={banner} alt='Banner' title='Banner' />
                    <div className='bannerbox'>
                        <Container>
                            <div className='banner-content'>
                                <h4>ABOUT US</h4>
                                <h1>Protection Built <br /> for <span>Every Storm</span></h1>
                                <p><b>India's first dedicated device protection brand</b></p>
                                <p>Tempered glass, cases, camera lens protectors, tablet and watch glass - one standard, three tiers, every device covered.</p>
                            </div>
                        </Container>
                    </div>
                </div>
            </section>

            <section id='visionmission'>
                <div className='visionmission-block'>
                    <Container>
                        <div className='visionmission-box'>
                            <div className='sctiontitle'>
                                <h4>OUR PURPOSE</h4>
                                <h1>Mission <span>&</span> Vision</h1>
                            </div>
                            <Row>
                                <Col md={6}>
                                    <div className='visi-box Vision'>
                                        <img src={OurVision} alt='Our Vision' title='Our Vision' />
                                        <div className='contentboxs'>
                                            <h4>Our Vision</h4>
                                            <p>Our vision is simple: <span>trusted device protection</span> for every home, every device, and <span>every budget</span> with <span>best quality</span>.</p>
                                            <ul>
                                                <li>
                                                    <div className='iconsboxs'><FaShield /></div>
                                                    <span>Trusted</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaHouse /></div>
                                                    <span>Home</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaMobileButton /></div>
                                                    <span>Device</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaTags /></div>
                                                    <span>Budget</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className='visi-box Mission'>
                                        <img src={OurMission} alt='Our Mission' title='Our Mission' />
                                        <div className='contentboxs'>
                                            <h4>Our Mission</h4>
                                            <p>To make <span>premium device protection</span> accessible to everyone through innovative, reliable, and affordable solutions.</p>
                                            <ul>
                                                <li>
                                                    <div className='iconsboxs'><FaShield /></div>
                                                    <span>Reliable</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaMobileButton /></div>
                                                    <span>Innovative</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaUserGroup /></div>
                                                    <span>Accessible</span>
                                                </li>
                                                <li>
                                                    <div className='iconsboxs'><FaHandHoldingDollar /></div>
                                                    <span>Affordable</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
            </section>

            <section id='story'>
                <div className='story-block'>
                    <Container>
                        <div className='story-box'>
                            <div className='sctiontitle'>
                                <h1>OUR STORY</h1>
                            </div>
                            <p>MobiStorm was built with one simple idea: your everyday devices deserve better protection.From tempered glass for phones, tablets and iPads to watch protectors, camera lens protectors, and stylish phone cases &amp; covers, we have options for every device, need and budget. we offer products that help keep the devices you rely on safe from everyday scratches, drops and wear.</p>
                            <p>We believe protection should not be overpriced, which is why we bring together reliable quality, precise fits and thoughtful designs at prices that work for everyone. Our range covers everything from everyday essentials to enhanced and premium protection, so there’s something for every need and budget.</p>
                            <p> For those who choose our Premium Tempered Glass, we go a step further with a 2-times replacement warranty valid for one year, giving you extra confidence in your purchase. With innovations like our Magic Box self-applicator tempered glass, we’re also making protection easier to use at home. At MobiStorm, We’re building a protection brand that makes looking after your devices simple, reliable and accessible.</p>
                        </div>
                    </Container>
                </div>
            </section>

            <section id='way'>
                <div className='way-block'>
                    <Container>
                        <div className='sctiontitle'>
                            <h1>Why Choose  <span>Mobistorm?</span></h1>
                        </div>
                        <div className='way-box'>
                            <Row>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.4 8.6 8 11 4.6-2.4 8-6 8-11V5l-8-3Z" /><path d="m8.5 12 2.5 2.5 4.5-4.5" /></svg></span>
                                            <h3>Complete<br />Device Protection</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Protection for mobiles, tablets, iPads and smartwatches, all in one place.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /><path d="m3 17 9 5 9-5" opacity=".6" /></svg></span>
                                            <h3>Protection for<br />Every Budget</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Essential, Mid and Premium ranges designed for different needs and budgets.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="6" /><path d="m12 6.4 1 2 2.2.2-1.7 1.5.6 2.1-2.1-1.2-2.1 1.2.6-2.1L8.8 8.6l2.2-.2 1-2Z" fill="currentColor" stroke="none" /><path d="m8.5 14.5-1.8 6 5.3-2.6 5.3 2.6-1.8-6" /></svg></span>
                                            <h3>Premium Quality<br />&amp; Precise Fit</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Quality materials, precision manufacturing and model-specific fit for perfect protection.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7Z" /><path d="m4 8.5 8 4.5 8-4.5M12 13v7" /><path d="M17 3.5v3M18.5 5h-3" opacity=".9" /></svg></span>
                                            <h3>Innovative<br />Protection</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Featuring our Magic Box Self-Applicator Tempered Glass for easy installation at home.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5 3.4 8.6 8 11 4.6-2.4 8-6 8-11V5l-8-3Z" /><path d="m8.5 12 2.5 2.5 4.5-4.5" /></svg></span>
                                            <h3>Warranty<br />Benefits</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Selected Premium Range products come with warranty benefits for added confidence.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.3-5.6" /><path d="M20 4v4h-4" /></svg></span>
                                            <h3>Always<br />Up to Date</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Regularly updated products covering the latest device models.</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='waycard'>
                                        <div className="top">
                                            <span className="au-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13 11 6l7 .5.5 7L11.5 20 4 13Z" /><circle cx="14.5" cy="9.5" r="1.3" /><path d="M8 3.5v3M9.5 5h-3" opacity=".9" /></svg></span>
                                            <h3>Quality at the<br />Right Price</h3>
                                        </div>
                                        <div className="cbar"></div>
                                        <p>Reliable, thoughtfully designed protection without unnecessary premium pricing.</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div >
            </section >

            <Footer />
        </>
    )
}

export default Aboutus